<div class="container-fluid px-4 mt-4 mb-5">
    <div class="cp-page-header mb-4">
        <div class="cp-page-title"><i class="fa-solid fa-building me-2"></i>Mis instalaciones</div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Inicio</a></li>
                <li class="breadcrumb-item active">Instalaciones</li>
            </ol>
        </nav>
    </div>

    <div class="card">
        <div class="card-header cp-list-header">
            <span class="cp-list-title">Listado de instalaciones <span class="badge bg-primary ms-2">{{ collectionSize }}</span></span>
            <button class="btn btn-outline-secondary btn-sm" (click)="getData()" [disabled]="loading">
                <i class="fa-solid fa-rotate me-1" [class.fa-spin]="loading"></i>Actualizar
            </button>
        </div>
        <div class="card-body p-0">
            <div class="text-center text-muted py-5" *ngIf="loading"><div class="spinner-border spinner-border-sm me-2"></div>Cargando instalaciones…</div>

            <div class="table-responsive" *ngIf="!loading && items?.length > 0">
                <table class="table cp-table align-middle mb-0">
                    <thead>
                        <tr><th>Instalación</th><th>RUT</th><th>Teléfono</th><th>Email</th><th>Creación</th><th></th></tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items">
                            <td class="fw-bold">{{ item.name | titlecase }}<div class="small text-muted fw-normal">ID #{{ item.id }}</div></td>
                            <td class="small">{{ formatRut(item.rut) }}</td>
                            <td class="small">{{ item.phone ? formatPhone(item.phone) : '—' }}</td>
                            <td class="small">{{ item.email ? (item.email | lowercase) : '—' }}</td>
                            <td class="small text-nowrap">{{ item.created_at | date:'dd-MM-yyyy' }}</td>
                            <td class="text-end">
                                <button type="button" class="btn btn-sm btn-outline-primary" (click)="goToView(item.id)" title="Ver la instalación">
                                    <i class="fa-solid fa-eye me-1"></i>Ver
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="cp-empty" *ngIf="!loading && items?.length === 0">
                <i class="fa-solid fa-building"></i>No hay instalaciones asignadas a su supervisión.
            </div>

            <div class="d-flex justify-content-between align-items-center border-top px-3 py-2" *ngIf="!loading && items?.length > 0">
                <small class="text-muted">Mostrando {{ (page - 1) * perpage + 1 }} - {{ Math.min(page * perpage, collectionSize) }} de {{ collectionSize }}</small>
                <ngb-pagination class="mb-0" [maxSize]="5" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage" [rotate]="true" [boundaryLinks]="true" (pageChange)="search()"></ngb-pagination>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<ng-template #remove let-c="close" let-d="dismiss">
    <form (submit)="delete()" novalidate [formGroup]="form">
        <div class="modal-header">
            <h4 class="modal-title text-danger">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Eliminar Instalación
            </h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="text-center mb-3">
                <div class="alert-icon text-danger mb-3">
                    <i class="fas fa-trash-alt"></i>
                </div>
                <p class="mb-3">¿Estás seguro que deseas eliminar esta instalación?</p>
            </div>
            <div class="alert alert-warning border-warning">
                <div class="d-flex">
                    <i class="fas fa-exclamation-triangle text-warning me-2 mt-1"></i>
                    <div>
                        <strong>Importante:</strong> Esta operación eliminará todas las dependencias,
                        usuarios administradores y registros asociados. No puede ser restaurada.
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="d('Cross click')">
                <i class="fas fa-times me-1"></i>
                Cancelar
            </button>
            <button type="submit" ngbAutofocus class="btn btn-danger">
                <i class="fas fa-trash me-1"></i>
                Eliminar
            </button>
        </div>
    </form>
</ng-template>

<!-- Add Modal -->
<ng-template #add let-c="close" let-d="dismiss">
    <div class="modal-body">
        <app-add-facility (success)="getData()"></app-add-facility>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="d('Cross click')">
            <i class="fas fa-times me-1"></i>
            Cancelar
        </button>
    </div>
</ng-template>